import { type FC } from 'react';
import { Checkbox, Select, SelectItem } from '@carbon/react';
import { TITLE_SUPPORT_SOURCES, type TitleSupportDetails } from './types';

// Two coverage flags, not one "type": a report can carry both.

const COVERAGE_FIELDS = [
  ['fullRunsheet', 'title-support-full-runsheet', 'Full runsheet'],
  ['ownership', 'title-support-ownership', 'Ownership'],
] as const;

interface Props {
  value: TitleSupportDetails;
  onChange: (next: TitleSupportDetails) => void;
}

export const ExternalTitleSupportFields: FC<Props> = ({ value, onChange }) => (
  <>
    <Select
      id="title-support-source"
      labelText="Source"
      value={value.source ?? ''}
      onChange={(event) => onChange({ ...value, source: event.target.value })}
    >
      <SelectItem value="" text="Choose a source" />
      {TITLE_SUPPORT_SOURCES.map((source) => (
        <SelectItem key={source} value={source} text={source} />
      ))}
    </Select>

    {COVERAGE_FIELDS.map(([field, id, label]) => (
      <Checkbox
        key={field}
        id={id}
        labelText={label}
        checked={value[field] ?? false}
        onChange={(_event, { checked }) =>
          onChange({ ...value, [field]: checked })
        }
      />
    ))}
  </>
);
